<div (clickOutside)="close()" class="white-bg">
    <div (click)="clickIcon('circle')" class="circle-icon"></div>

    <div (click)="clickIcon('line')" class="flex draw-toolbar-container">
        <div class="legend-color-link"></div>
        <div class="legend-arrow-right"></div>
    </div>

    <img (click)="clickIcon('clear')" [src]="'./assets/app/img/icons/clear_black.svg'">
</div>
